// src\components\VideoEngine\Common\SmartBackground.js

// This component handles the subtle "Handheld" camera feel (rotation + drift) to prevent 
// static images from looking boring.

import React from "react";
import {
  AbsoluteFill,
  Img,
  Video,
  useCurrentFrame,
  interpolate,
  Easing,
} from "remotion";

export const SmartBackground = ({
  src,
  duration = 90, // Default safety
}) => {
  const frame = useCurrentFrame();

  if (!src) return <AbsoluteFill style={{ background: "#333" }} />;

  const isVideo = src.endsWith(".mp4") || src.endsWith(".webm");

  // 1. SCALING: Gentle zoom out (1.15x -> 1.0x)
  // Extrapolate 'clamp' ensures it doesn't shrink below 100%
  const scale = interpolate(frame, [0, duration], [1.15, 1.0], {
    easing: Easing.out(Easing.quad),
    extrapolateRight: "clamp",
  });

  // 2. ROTATION: Subtle "Handheld" rotation (-1deg -> 1deg)
  const rotate = interpolate(frame, [0, duration], [-1, 1], {
    easing: Easing.inOut(Easing.sin),
  });

  // 3. DRIFT: Subtle pan right (0px -> 20px)
  const translateX = interpolate(frame, [0, duration], [0, 20], {
    easing: Easing.linear,
  });

  if (isVideo) {
    return (
      <AbsoluteFill>
        <Video
          src={src}
          style={{ height: "100%", width: "100%", objectFit: "cover" }}
          startFrom={0}
          muted={true}
          loop
        />
        <AbsoluteFill style={{ backgroundColor: "rgba(0,0,0,0.2)" }} />
      </AbsoluteFill>
    );
  }

  return (
    <AbsoluteFill style={{ overflow: "hidden" }}>
      <Img
        src={src}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          // The "Handheld" Transform Stack
          transform: `scale(${scale}) rotate(${rotate}deg) translateX(${translateX}px)`,
          transformOrigin: "center 20%",
        }}
      />
    </AbsoluteFill>
  );
};